import {Divider, Space} from 'antd';
import React from 'react';
import {PreviewInvoice} from 'routes/Account/Billing/PreviewInvoice';
import {UpdateInvoice} from 'routes/Account/Billing/UpdateInvoice';
import {InvoiceProps} from './types';

export const InvoiceActions: React.FC<InvoiceProps> = ({invoice, account}) => {
  return (
    <Space split={<Divider type="vertical" />}>
      <UpdateInvoice invoice={invoice} />
      <PreviewInvoice invoice={invoice} account={account} />
    </Space>
  );
};
